import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27b5bae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section"
}
const _hoisted_2 = { class: "section__header" }
const _hoisted_3 = { class: "section__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "›", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "section__scroll" }
const _hoisted_8 = { class: "section__track" }
const _hoisted_9 = { class: "shelf-card__cover" }
const _hoisted_10 = {
  key: 1,
  class: "shelf-card__badge"
}
const _hoisted_11 = { class: "shelf-card__title" }
const _hoisted_12 = {
  key: 0,
  class: "shelf-card__price"
}

import { computed } from "vue";
import { Image as VanImage } from "vant";
import {
  getHotspotCurrencySymbol,
  getHotspotPriceValue,
  getHotspotShelfTypeLabel,
  hasHotspotPriceContent,
} from "../model";
import type { HotspotShelfSection } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShelfCarousel',
  props: {
    section: null
  },
  emits: ["open-app"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-app"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: HotspotShelfSection;
}





const sectionTitle = computed(() => {
  const count = props.section?.count;
  return [props.section?.title, count === undefined ? "" : String(count)]
    .filter(Boolean)
    .join(" ");
});

return (_ctx: any,_cache: any) => {
  return (__props.section?.list?.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(sectionTitle)), 1),
          _createElementVNode("div", {
            class: "section__action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-app')))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.list, (item, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: item.id || index,
                class: "shelf-card",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('open-app')))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (item.cardDisplay?.cover)
                    ? (_openBlock(), _createBlock(_unref(VanImage), {
                        key: 0,
                        fit: "cover",
                        class: "shelf-card__cover-image",
                        src: item.cardDisplay?.cover,
                        alt: item.cardDisplay?.title || ''
                      }, null, 8, ["src", "alt"]))
                    : _createCommentVNode("", true),
                  (_unref(getHotspotShelfTypeLabel)(item.type))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(getHotspotShelfTypeLabel)(item.type)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cardDisplay?.titlePrefix, (prefix, prefixIndex) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `${prefix.text || ''}-${prefixIndex}`,
                      class: "shelf-card__prefix",
                      style: _normalizeStyle({ color: prefix.color || '#000' })
                    }, _toDisplayString(prefix.text), 5))
                  }), 128)),
                  _createElementVNode("span", null, _toDisplayString(item.cardDisplay?.title), 1)
                ]),
                (_unref(hasHotspotPriceContent)(item.cardDisplay?.price))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(item.cardDisplay?.price?.prefix), 1),
                      (_unref(getHotspotPriceValue)(item.cardDisplay?.price))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", null, _toDisplayString(_unref(getHotspotCurrencySymbol)(item.cardDisplay?.price?.currency)), 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(getHotspotPriceValue)(item.cardDisplay?.price)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.cardDisplay?.price?.suffix), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})